import { useSetAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import React, { useCallback } from 'react';

import { Name, Table } from '~/components/blocks';
import { ContactMethod } from '~/components/pages/Patient/AllPatientList/AllPatient/ContactMethod';
import { CheckinEntryOnAllPatientListFragment } from '~/graphql/generated/graphql';
import {
  newPatientDrawerState,
  newPatientFromCheckinEntryDrawerState,
} from '~/state/patient/atoms';

import { QuestionnaireSheetColumn } from './QuestionnaireSheetColumn';

type Props = {
  checkinEntry: CheckinEntryOnAllPatientListFragment;
};

export const CheckinEntry = React.memo(({ checkinEntry }: Props) => {
  const setNewPatientFromCheckinEntryDrawerState = useSetAtom(
    newPatientFromCheckinEntryDrawerState,
  );
  const resetNewPatientDrawerState = useResetAtom(newPatientDrawerState);
  const handleClick = useCallback(() => {
    setNewPatientFromCheckinEntryDrawerState((_state) => ({
      ..._state,
      isOpen: true,
      checkinEntryId: checkinEntry.id,
    }));

    resetNewPatientDrawerState();
  }, [setNewPatientFromCheckinEntryDrawerState, checkinEntry.id, resetNewPatientDrawerState]);

  return (
    <Table.Tr onClick={handleClick}>
      <Table.Td>
        <Name
          familyName={checkinEntry.familyName}
          givenName={checkinEntry.givenName}
          phoneticFamilyName={checkinEntry.phoneticFamilyName}
          phoneticGivenName={checkinEntry.phoneticGivenName}
        />
      </Table.Td>
      <Table.Td>-</Table.Td>
      <Table.Td>
        <ContactMethod phoneNumber={checkinEntry.phoneNumber} />
      </Table.Td>
      <Table.Td>-</Table.Td>
      <Table.Td></Table.Td>
      <Table.Td>
        <QuestionnaireSheetColumn
          latestSentFollowupMessage={null}
          latestSentFollowupAutoReplyMessage={null}
        />
      </Table.Td>
      <Table.Td></Table.Td>
      <Table.Td>-</Table.Td>
    </Table.Tr>
  );
});

CheckinEntry.displayName = 'CheckinEntry';
